import React from 'react';

export default function () {
    
    return <div> Page Not Found</div>
}

